import React from 'react';
import styled from 'styled-components';

import { useDispatch } from 'react-redux';
import {
  ButtonWithSearchResults,
  InputDatepickerRange,
} from '../../molecules';
import {
  SearchTypeList,
  // getSearchAllList,
  getSearchClientsList,
  // getSearchEmployeeList,
  getSearchInspectionsList,
  getSearchPermitsList,
  // getSearchPmList,
  getSearchTicketsList,
  getSearchActivitiesList,
} from '../../api/search';

import { DEFAULT_DATE_FORMAT, GET_ALL_QUERY_PARAMS } from '../../constants';
import { setSearchButton } from '../../redux/slices/filterSlice';

const buttonValues = [
  [
    {
      id: 1,
      name: 'Inspections',
      keyName: 'inspections',
      apiCallBackFn: getSearchInspectionsList,
    },
    {
      id: 2,
      name: 'Reviews',
      keyName: 'permitActivity',
      apiCallBackFn: getSearchActivitiesList,
    },
  ],
 ];

const ButtonsResultsPanelInspector = ({
  className,
  searchValuesData,
  setEndpoint,
  setActiveTabName,
  setDates,
}: ButtonsResultsPanelTypes) => {
  const [activeButton, setActiveButton] = React.useState<
    string
  >('');
  const dispatch = useDispatch();
  // React.useEffect(() => {
  //   if (
  //     searchValuesData &&
  //     Object.keys(searchValuesData).length
  //   ) {
  //     setActiveButton(buttonValues[0][0].keyName);
  //     setEndpoint(buttonValues[0][0].apiCallBackFn);
  //   }
  // }, [searchValuesData]);

  const handleClick = button => {
    setActiveTabName(button.keyName);
    setActiveButton(button.keyName);
    setEndpoint(button.apiCallBackFn);
    dispatch(setSearchButton(button.keyName));
  };

  return (
    <Container className={className}>
      <LeftButtonContainer>
        {buttonValues[0].map(button => (
          <ButtonWithSearchResults
            key={button.id}
            onClick={() => handleClick(button)}
            searchResult={searchValuesData[button.keyName]}
            className={
              button.keyName === activeButton
                ? 'active'
                : ''
            }
          >
            {button.name}
          </ButtonWithSearchResults>
        ))}

        {(activeButton === 'inspections' ||
          activeButton === 'permitActivity') && (
          <StyledInputDatepickerRange
            name="date"
            placeholderText="Select Date"
            dateFormat={DEFAULT_DATE_FORMAT}
            onRangeChange={(start, end) => {
              if (start && end) {
                setDates({ fromDate: start, toDate: end });
              }
            }}
          />
        )}
      </LeftButtonContainer>
    </Container>
  );
};

interface ButtonsResultsPanelTypes {
  className?: string;
  searchValuesData: SearchTypeList | object;
  setEndpoint: (data: any) => void;
  setActiveTabName: (data: any) => void;
  setDates: (data: any) => void;
}

const FONT_STACK = `'Segoe UI', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, Roboto, sans-serif`;

const Container = styled.div`
  margin-top: 16px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 12px;
  font-family: ${FONT_STACK};

  .MuiButton-root {
    text-transform: none;
    letter-spacing: 0.01em;
    border-radius: 8px;
    height: 40px;
    min-width: 140px;
    font-weight: 600;
    font-size: 0.875rem;
    font-family: ${FONT_STACK};
  }

  .MuiButton-containedPrimary.active {
    background-color: var(--primary-700) !important;
    color: var(--neutral-0);
  }
`;

const StyledInputDatepickerRange = styled(
  InputDatepickerRange,
)`
  margin-left: 2px;

  .MuiOutlinedInput-root.MuiInputBase-formControl {
    height: 40px;
    border-radius: 8px;
    background: var(--neutral-0);
    font-family: ${FONT_STACK};

    &.Mui-focused {
      box-shadow: var(--shadow-focus);
    }

    fieldset {
      border-color: var(--border);
    }

    &:hover fieldset {
      border-color: var(--neutral-500);
    }

    &.Mui-focused fieldset {
      border-color: var(--primary-600);
    }
  }
`;

const LeftButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 0;
  align-items: center;

  @media only screen and (max-width: 840px) {
    display: grid;
    grid-template-rows: auto;
    height: auto;
    grid-gap: 6px;
    width: 100%;
  }
`;

const RightButtonContainer = styled.div`
  display: flex;
`;

export default ButtonsResultsPanelInspector;
